(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scPaging/template', '<div class="sc-paging" ng-show="size && size/perPage > 1 && !loading">\n' + '  <div data-sc-paging-buttons="ui"></div>\n' + '</div>\n' + '');
}]);
})();